import { Injectable } from '@angular/core';

import { ConfigurationService } from "src/app/configurations/configurationService";
import { AppMainComponent } from "../app.main.component";
import { AppMainService } from "../app-main.service";
import { AccountService } from "../accounts/accountService";
import { LeadService } from "../leads/leadService";
import { AddEditAddressModalService } from '../modules/shared/components/address/address-add-update-modal/address-add-update-modal.service';

import { ObjectNames } from "../shared/constants";

import * as FileSaver from "file-saver";
import * as Excel from "exceljs";
import { StatusGroupIds, TypeGroupIds } from '../modules/shared/constants/category-groupid.constants';

@Injectable({
    providedIn: 'root',
})
export class ImportExcelService {
    excelHeader = [];
    ddList: any[] = [];
    selectedDDList: any[] = [];

    constructor(
        public appMainService: AppMainService,
        private configService: ConfigurationService,
        public app: AppMainComponent,
        private accountService: AccountService,
        private leadService: LeadService,
        private addEditAddressModalService: AddEditAddressModalService)
    {}

    async proceed(exportFields: any[]) {
        this.excelHeader = [];

        for (let data of exportFields) {
            const { name, formControl, custom } = data;

            this.excelHeader.push(name);

            if (formControl === "dropdownlist" || name === 'Job Function' || custom) {
                await this.callDropdownAPI(data);
            }
        }

        this.ddList.push({ name: 'State', values: [] });
    }

    async callDropdownAPI(data) {
        const { name, formControl, custom, PickListValues } = data;
        let values = [];

        switch (name) {
            case 'Rating': {
                this.appMainService.isShowSpinner("Rating");
                await this.accountService.getAllRatings()
                    .then(ratings => {
                        this.appMainService.isHideSpinner("Rating");
                        values = ratings.map(el => {
                            return { name: el.name }
                        });
                        this.ddList.push({ name, values });
                    })
                    .catch(() => {
                        this.appMainService.isHideSpinner("Rating");
                    });
                break;
            }
            case 'Lead Type(s)': {
                this.appMainService.isShowSpinner("Lead Type(s)");
                await this.leadService.getAllLeadTypes(TypeGroupIds.LeadTypeLeadAPI)
                    .then(types => {
                        this.appMainService.isHideSpinner("Lead Type(s)");
                        values = types.map(el => {
                            return { name: el.name }
                        });
                        this.ddList.push({ name, values });
                    })
                    .catch(() => {
                        this.appMainService.isHideSpinner("Lead Type(s)");
                    });
                break;
            }
            case 'Timezone': {
                this.appMainService.isShowSpinner("Timezone");
                await this.accountService.getTimezone()
                    .then(timezoneList => {
                        this.appMainService.isHideSpinner("Timezone");
                        values = timezoneList.map(el => {
                            return { name: el.name }
                        });
                        this.ddList.push({ name, values });
                    })
                    .catch(() => {
                        this.appMainService.isHideSpinner("Timezone");
                    });
                 break;
            }
            case 'Currency': {
                this.appMainService.isShowSpinner("Currency");
                await this.accountService.getCurrency()
                    .then(currencyList => {
                        this.appMainService.isHideSpinner("Currency");
                        values = currencyList;
                        values.forEach(el => {
                            el.label = el.name + ' - ' + el.code;
                            el.value = JSON.parse(JSON.stringify(el));
                        });
                        values = values.map(el => {
                            return { name: el.name + ' - ' + el.code }
                        });
                        this.ddList.push({ name, values });
                    })
                    .catch(() => {
                        this.appMainService.isHideSpinner("Currency");
                    });
                break;
            }
            case 'Number of Employees': {
                this.appMainService.isShowSpinner("Number of Employees");
                await this.leadService.getAllEmployeesCount()
                    .then(count => {
                        this.appMainService.isHideSpinner("Number of Employees");
                        values = count.map(el => {
                            return { name: el.name }
                        });
                        this.ddList.push({ name, values });
                    })
                    .catch(() => {
                        this.appMainService.isHideSpinner("Number of Employees");
                    });
                break;
            }
            case 'Estimated Annual Revenue': {
                this.appMainService.isShowSpinner("Estimated Annual Revenue");
                await this.leadService.getAllRevenues()
                    .then(revenue => {
                        this.appMainService.isHideSpinner("Estimated Annual Revenue");
                        values = revenue.map(el => {
                            return { name: el.name }
                        });
                        this.ddList.push({ name, values });
                    })
                    .catch(() => {
                        this.appMainService.isHideSpinner("Estimated Annual Revenue");
                    });
                break;
            }
            case 'Ownership Type': {
                this.appMainService.isShowSpinner("Ownership Type");
                await this.accountService.getAllOwnerships()
                    .then(owners => {
                        this.appMainService.isHideSpinner("Ownership Type");
                        values = owners.map(el => {
                            return { name: el.name }
                        });
                        this.ddList.push({ name, values });
                    })
                    .catch(() => {
                        this.appMainService.isHideSpinner("Ownership Type");
                    });
                break;
            }
            case 'Industry': {
                this.appMainService.isShowSpinner("Industry");
                await this.leadService.getAllIndustries()
                    .then(industries => {
                        this.appMainService.isHideSpinner("Industry");
                        values = industries.map(el => {
                            return { name: el.name }
                        });
                        this.ddList.push({ name, values });
                    })
                    .catch(() => {
                        this.appMainService.isHideSpinner("Industry");
                    });
                break;
            }
            case 'Lead Source': {
                this.appMainService.isShowSpinner("Lead Source");
                await this.leadService.getAllSources(this.app.user.organizationId)
                    .then(sources => {
                        this.appMainService.isHideSpinner("Lead Source");
                        values = sources.map(el => {
                            return { name: el.name }
                        });
                        this.ddList.push({ name, values });
                    })
                    .catch(() => {
                        this.appMainService.isHideSpinner("Lead Source");
                    });
                break;
            }
            case 'Status': {
                this.appMainService.isShowSpinner("Status");
                await this.leadService.getAllLeadStatus(StatusGroupIds.LeadStatusGroupId)
                    .then(statuses => {
                        this.appMainService.isHideSpinner("Status");
                        values = statuses.map(el => {
                            return { name: el.name }
                        });
                        this.ddList.push({ name, values });
                    })
                    .catch(() => {
                        this.appMainService.isHideSpinner("Status");
                    });
                break;
            }
            case 'Country': {
                this.appMainService.isShowSpinner("Country");
                await this.accountService.getAllCountries()
                    .then(countries => {
                        this.appMainService.isHideSpinner("Country");
                        values = countries.map(el => {
                            return { name: el.name, id: el.id }
                        });
                        this.ddList.push({ name, values });
                    })
                    .catch(() => {
                        this.appMainService.isHideSpinner("Country");
                    });
                break;
            }
            case 'Stage': {
                this.appMainService.isShowSpinner("Stage");
                await this.configService.getConfigurationByModuleName('Lead')
                    .toPromise()
                    .then(configs => {
                        this.appMainService.isHideSpinner("Stage");
                        const configJSONValueLead = configs.filter(s => s.name == ObjectNames.LEAD_CHANNEL
                        && s.typeId == 97)[0]?.configurationDetails[0]?.configJSONValue;
                        const leadChannel = configJSONValueLead ? JSON.parse(configJSONValueLead) : [];
                        const pipeline = leadChannel.find(el => el.isDefault == true);
                        values = pipeline?.selectedStages?.sort((a, b) => a.displayOrder - b.displayOrder).map(el => {
                            return { name: el.name }
                        });
                        values = values || [];
                        this.ddList.push({ name, values });
                    })
                    .catch(() => {
                        this.appMainService.isHideSpinner("Stage");
                    });
                break;
            }
            case 'Job Function': {
                this.appMainService.isShowSpinner("Job Function");
                await this.configService.getContactRoles().subscribe(roles => {
                    this.appMainService.isHideSpinner("Job Function");
                    values = roles.map(el => {
                        return { name: el.name }
                    });
                    this.ddList.push({ name, values });
                }, () => {
                    this.appMainService.isHideSpinner("Job Function");
                });
                break;
            }
            default: {
                if (custom && ['DropDownList', 'MultipleDropDownList'].includes(formControl) && PickListValues) {
                    values = JSON.parse(PickListValues);
                    values = values.map(el => {
                        return { name: el.name || el.Name }
                    });
                    this.ddList.push({ name, values });
                }
                break;
            }
        }
    }

    onSelectCountry({ value }) {
        const length = this.ddList.length;
        const index = this.selectedDDList.findIndex(el => el.name === 'Country');
        const stateIndex =  this.selectedDDList.findIndex(el => el.name === 'State');

        if (index === -1) {
            this.selectedDDList.push({ name, values: [value.name] });
        } else {
            this.selectedDDList[index].values = [value.name];
        }

        if (index > -1) {
            this.selectedDDList[stateIndex - 1].values = [];
        }

        this.addEditAddressModalService.getAllStates(value.id)
            .then(states => {
                this.ddList[length-1].values = states;
            });
    }

    onMultiSelect(name, { value }) {
        const index = this.selectedDDList.findIndex(el => el.name === name);
        let ddValues = value;

        if (name === 'State') {
            const length = this.ddList.length;
            const states = this.ddList[length - 1];
            ddValues = [];

            for (let data of value) {
                if (states.values.find(state => state.name === data)) {
                    ddValues.push(data)
                }
            }
        }

        if (index === -1) {
            this.selectedDDList.push({ name, values: ddValues });
        } else {
            this.selectedDDList[index].values = ddValues;
        }
    }

    downloadDDExcel(moduleName: string, headers?: any[], rowData?: any[]) {
        let workbook = new Excel.Workbook();
        let worksheet = workbook.addWorksheet('Excel DD Data');

        // Add Header Row
        let headerRow = headers ? worksheet.addRow(headers) : worksheet.addRow(this.excelHeader);

        if (rowData) {
            rowData = rowData[0];
            rowData.shift();
        }

        // Header Font Bold and Add Data and Conditional Formatting
        headerRow.eachCell((cell: any) => {
            const headerValue = cell._value.model.value;
            const foundData = this.selectedDDList.find(el => el.name === headerValue);
            const rowLimit = rowData ? (rowData.length + 1) : 1000;

            if (foundData) {
                for (let i = 2; i <= rowLimit; i++) {
                    const columnName = cell._address.replace('1', i);
                    const joinedDDlist = "\"" + foundData.values?.join(',') + "\"";
                    worksheet.getCell(columnName).dataValidation = {
                        type: 'list',
                        allowBlank: true,
                        formulae: [joinedDDlist]
                    };
                }
            } else {
                if (rowData) {
                    for (let i = 2; i <= rowLimit; i++) {
                        const columnName = cell._address.replace('1', i);
                        // worksheet.getCell(columnName).dataValidation = {
                        //     type: 'textLength',
                        //     operator: 'lessThanOrEqual',
                        //     allowBlank: true,
                        //     formulae: [100]
                        // };
                        // worksheet.getCell(columnName).note = rowData[i-2];
                    }
                }
            }

            cell.font = {
                bold: true
            };
        });

        const fileName = rowData ? `${moduleName}_export_${new Date().getTime()}` : `${moduleName}_${new Date().getTime()}`;

        workbook.xlsx.writeBuffer().then((data) => {
            let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            FileSaver.saveAs(blob, `${fileName}.xlsx`);
        });

        this.ddList = [];
        this.selectedDDList = [];
    }
}
